import logo from "../assets/logo.png";
import product from "../assets/product.jpg";
import "./connected_header.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";


function Connected_header({ name }) {
  const navigate = useNavigate();
  const [userPicture, setUserPicture] = useState(null);

  https: useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    if (token) {
      fetch(
        "https://happer-test.francecentral.cloudapp.azure.com/api/users/me",
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          setUserPicture(data.picture);
        })
        .catch((error) => console.error(error));
    } else {
      console.log("No token found !!!!!!");
    }
  }, []);


  return (
    <header className="Connected_header">
      <img className="header_logo" src={logo} alt="Happer LOGO" />
      <h4 className="happer">Happer</h4>
      <p className="left_text">for influencer</p>
      <div className="space_div"></div>
      <div className="logo_container">
        <img
          className="profile_logo"
          onClick={() => navigate("/profile")}
          src={userPicture ? userPicture : product}
          alt="user image"
        />
      </div>
      <h3 className="right_text" onClick={() => navigate("/profile")}>{name}</h3>
    </header>
  );
}

export default Connected_header;
